import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	IconTimeLight,
	Text3,
	skinVars,
	useScreenSize,
	Text1,
} from "@telefonica/mistica";
import React, { useCallback } from "react";

import { strings } from "../../localization";
import { FeedbackContainer, ScreenResponsive } from "../../components";
import { observer } from "mobx-react-lite";
import { useNavigateCustom } from "../../hooks";
import { useLocation } from "react-router-dom";

interface LocationState {
	code?: string;
	errorMessage?: string;
}

const SystemMaintenance: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { description, title } = strings.pages.systemMaintenance;
	const { toGoOut } = strings.components.buttons;
	const location = useLocation();
	const state = location.state as LocationState;

	const onHandleToGoOut = useCallback(() => {
		navigation("/");
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={<IconTimeLight size={64} color={skinVars.colors.brand} />}
					title={title}
					description={state.code && state.errorMessage ?
						<>
							{state.errorMessage}
							<br />
							<Text1 regular >{state.code}</Text1>
						</>
						: description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={onHandleToGoOut} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{toGoOut}
							</Text3>
						</ButtonPrimary>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default SystemMaintenance;
